/**
 * Central API Configuration
 * All API endpoints are defined here
 */

const API_BASE_URL =  'https://prod-api.botguru.ai/api/v1/';

export const API_ENDPOINTS = {
  // Dashboard endpoints
  DASHBOARD: {
    STATS: '/dashboard/stats',
    CHARTS: '/dashboard/charts',
  },
  
  // Students endpoints
  STUDENTS: {
    LIST: '/accounts/university/students/list/',
    RESULTS: '/accounts/university/students/results/',
    DETAIL: (id) => `/students/${id}`,
    CREATE: '/students',
    UPDATE: (id) => `/students/${id}`,
    DELETE: (id) => `/students/${id}`,
    SEARCH: '/students/search',
  },
  
  // Assessments endpoints
  ASSESSMENTS: {
    LIST: '/assessments',
    DETAIL: (id) => `/assessments/${id}`,
    CREATE: '/assessments',
    UPDATE: (id) => `/assessments/${id}`,
    DELETE: (id) => `/assessments/${id}`,
    PUBLISH: (id) => `/assessments/${id}/publish`,
    UNPUBLISH: (id) => `/assessments/${id}/unpublish`,
    PERFORMANCE: (id) => `/assessments/${id}/performance`,
  },
  
  // Account endpoints
  ACCOUNT: {
    PROFILE: '/account/profile',
    UPDATE_PROFILE: '/account/profile',
    SETTINGS: '/account/settings',
    UPDATE_SETTINGS: '/account/settings',
  },
};

export const getApiUrl = (endpoint) => {
  return `https://prod-api.botguru.ai/api/v1${endpoint}`;
};
